import { Link } from '../../cdl/Link/Link';
import { Text } from '../../cdl/Text/Text';
import { formatDate } from '../../common/helpers/formatDate.helper';
import { formatMoney } from '../../common/helpers/formatMoney.helper';
import { formatNumber } from '../../common/helpers/formatNumber.helper';
import { translate } from '../../common/helpers/translate.helper';
import { Characters } from '../../common/helpers/unicode.helper';
import { Box } from '../../common/ui/Box';
import { hasSupplierSubscriptionPlanSpecialOffer } from '../hasSupplierSubscriptionPlanSpecialOffer';
import { SupplierSubscriptionPlanMessage } from '../types/SupplierSubscriptionPlanMessage';

interface SupplierSubscriptionPlanNotesProps {
    professional: SupplierSubscriptionPlanMessage;
}

export const SupplierSubscriptionPlanNotes = ({ professional }: SupplierSubscriptionPlanNotesProps) => (
    <Box display="flex" flexDirection="column" gap={16}>
        <Box display="flex" flexDirection="column" gap={8}>
            <Text variant="extraSmall" color="foreground.muted">
                {translate('supplierSubscriptionPlans.billingTerms')}
            </Text>
            {hasSupplierSubscriptionPlanSpecialOffer(professional) &&
            professional.specialOfferValidUntil !== undefined &&
            professional.specialOfferTransactionFeePercentage !== undefined &&
            professional.monthlyPrice !== undefined &&
            professional.annualPrice !== undefined ? (
                <Text variant="extraSmall" color="foreground.muted">
                    {translate('supplierSubscriptionPlans.offerTerms', {
                        date: formatDate({ date: professional.specialOfferValidUntil, timeZone: 'UTC' }),
                        specialFee: formatNumber({
                            number: professional.specialOfferTransactionFeePercentage,
                            minimumFractionDigits: 1,
                        }),
                        monthlyPrice: formatMoney(professional.monthlyPrice),
                        annualPrice: formatMoney(professional.annualPrice),
                        regularFee: formatNumber({
                            number: professional.transactionFeePercentage,
                            minimumFractionDigits: 1,
                        }),
                    })}
                </Text>
            ) : null}
        </Box>
        <Text variant="small" color="foreground.muted">
            <Link href="https://website.closelink.com/supplier" size="small">
                {translate('supplierSubscriptionPlans.learnMore')}
            </Link>
            {Characters.NO_BREAK_SPACE}
            {translate('supplierSubscriptionPlans.comparisonHelp')}
        </Text>
    </Box>
);
